import { Outlet } from 'react-router-dom';

import { ChatBubble } from '@/components/chat/ChatBubble';
import { ChatPanel } from '@/components/chat/ChatPanel';
import { FloatingCallWindow } from '@/components/contacts/FloatingCallWindow';
import { Sidebar } from '@/components/Sidebar';
import { PendingSignaturesAlert } from '@/components/signatures/PendingSignaturesAlert';
import { useGlobalToolWatchNotifications } from '@/hooks/useGlobalToolWatchNotifications';
import { useChatStore } from '@/stores/chat.store';
import { useSidebarStore } from '@/stores/sidebar.store';

export const Layout = () => {
  const isOpen = useChatStore((s) => s.isOpen);
  const sidebarCollapsed = useSidebarStore((s) => s.collapsed);
  const setSidebarCollapsed = useSidebarStore((s) => s.setCollapsed);
  useGlobalToolWatchNotifications();

  return (
    <div className="bg-background flex h-screen">
      <Sidebar collapsed={sidebarCollapsed} onCollapsedChange={setSidebarCollapsed} />
      <main
        className="scrollbar-none flex-1 overflow-y-auto p-8 transition-[margin-right] duration-300"
        style={{ marginRight: isOpen ? 400 : 0 }}
      >
        <Outlet />
      </main>
      {isOpen && (
        <div className="fixed top-0 right-0 bottom-0 z-40 w-[400px]">
          <ChatPanel />
        </div>
      )}
      <ChatBubble />
      <FloatingCallWindow />
      <PendingSignaturesAlert />
    </div>
  );
};
